import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';

class DropDownChonCapCoQuanDaGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getCapCoQuanDaGiaiQuyet.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'capCoQuanDaGiaiQuyet',
            data: res.data && res.data._embedded && res.data._embedded.capCoQuanQuanLies ? res.data._embedded.capCoQuanQuanLies : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label="Cấp cơ quan đã giải quyết" selectedValue={this.props.selectedValue} options={ this.state.data } keyName='capCoQuanQuanLyId' valueName='ten' onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    )
  }
}

DropDownChonCapCoQuanDaGiaiQuyet.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.capCoQuanDaGiaiQuyet
  }
}

export default connect(bindStateToProps)(DropDownChonCapCoQuanDaGiaiQuyet);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-choncapcoquandagiaiquyet.jsx